import { render, staticRenderFns } from "./SummaryDetails.vue?vue&type=template&id=64fbec6c&scoped=true&"
import script from "./SummaryDetails.vue?vue&type=script&lang=js&"
export * from "./SummaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./SummaryDetails.vue?vue&type=style&index=0&id=64fbec6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbec6c",
  null
  
)

export default component.exports